module.exports = __webpack_public_path__ + "img/backTop.a758599e.png";